import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Betaalmethode',
    [BillingMode.InternalInvoicing]: 'Uitbetalingen',
  },
};
